<ng-container *transloco="let t">
  <section class="content-products">
    <div class="ui-title" [class.single-category]="isSingleActiveCategory()">
      @if (!isSingleActiveCategory()) {
        <a class="ui-item-link" [routerLink]="['../']">
          <pxw-icon icon="back" />
        </a>
      }
      <span class="category-title">
        {{ category() | propInSelectedLanguage: 'name' : selectedLanguage() : true }}
      </span>
      <div class="action-buttons">
        @if (productTagsWithQuantities().length > 0) {
          <pxw-button
            size="sm"
            [rounded]="true"
            color="theme2-contrast"
            (click)="onFilterProducts()"
          >
            <pxw-icon icon="filter" />
            {{ t('productFiltersDialog.title') }}
          </pxw-button>
        }
        @if (displayShareButton()) {
          <app-share-button
            [url]="shareUrl()"
            [shareText]="t('productList.shareText')"
            [buttonColor]="'theme2-contrast'"
          />
        }
      </div>
    </div>

    @if (productsByGroup()) {
      <pxw-item-list
        [groupingStrategy]="groupingStrategy()"
        [itemListGroups]="productsByGroup()"
        [emptyListText]="t('productList.emptyList')"
        [itemHeight]="100"
        [rememberScrollSettings]="{ key: 'category', context: categoryId() }"
        [autoHideSlider]="true"
      >
        <ng-template
          #layoutTemplate
          let-horizontalSliderTemplate="horizontalSliderTemplate"
          let-itemListTemplate="itemListTemplate"
        >
          <ng-container *ngTemplateOutlet="horizontalSliderTemplate" />

          <div>
            @if ((category() | pxwIsCategoryAvailable$ | async) === false && !isCartDisabled()) {
              <div class="not-available-wrapper">
                <pxw-alert class="not-available-alert" type="warning" size="sm">
                  <pxw-icon icon="clock" />
                  <div class="not-available-content">
                    {{ t('categoryAvailability.productsNotAvailable') }}
                    <pxw-button
                      color="yellow"
                      size="sm"
                      [rounded]="true"
                      (click)="categoryAvailabilityDialog.open(category())"
                    >
                      {{ t('categoryAvailability.checkSchedule') }}
                    </pxw-button>
                  </div>
                </pxw-alert>
                <pxw-category-availability-dialog #categoryAvailabilityDialog />
              </div>
            }
          </div>
          <ng-container *ngTemplateOutlet="itemListTemplate" />
        </ng-template>
        <ng-template #listItemTemplate let-product="item" let-listIndex="index">
          <app-product-list-item
            class="product-list-item"
            [id]="product.id"
            [name]="product.name"
            [image]="product.images?.[0]"
            [price]="product.price"
            [priceDiscount]="product.priceDiscount"
            [sku]="product.sku"
            [displaySku]="displaySku()"
            [withoutStock]="(product | pxwStockIsOutOfStock | async) ?? false"
            [purchaseRestrictions]="product"
            [purchaseOptions]="purchaseOptions()"
            [tag]="product.primaryTag"
            [presentationItems]="product.presentations?.items"
            [currencySymbol]="currencySymbol()"
            [detailRoute]="['/categoria', categoryId(), 'producto', product.id]"
            [listIndex]="listIndex"
            [promotions]="getPromotionsForProduct(product.id)"
          ></app-product-list-item>
        </ng-template>
      </pxw-item-list>
    }

    <app-show-order></app-show-order>
  </section>

  @if (productTagsWithQuantities().length > 0) {
    <app-product-filters-dialog
      [tagsWithQuantities]="productTagsWithQuantities()"
      [selectedTagIds]="selectedTagIds()"
      (selectedTagIdsChange)="onSelectedTags($event)"
    />
  }
</ng-container>
